module.exports = __webpack_public_path__ + "static/media/41.78ccc8bf.jpg";